:host {
  display: block;
}

::slotted(*:not(:last-child)) {
  margin-bottom: var(--spacing);
}
